// extracted by mini-css-extract-plugin
export default {"base":"AnimatePresence-module__base__NZELB","show":"AnimatePresence-module__show__BqVNv","hide":"AnimatePresence-module__hide__Iff9X"};